import { call, put, takeLatest } from "redux-saga/effects"
import { GET_LEADERBOARDS } from "./actionTypes"
import { getLeaderboardDetails } from "./api"
import { getLeaderboardsSuccess, getLeaderboardsFailure } from "./actions"
function* getLeaderboards() {
  try {
    const { data } = yield call(getLeaderboardDetails)
    yield put(getLeaderboardsSuccess(data))
  } catch {
    yield put(getLeaderboardsFailure())
  }
}
export default function* leaderboardSaga() {
  yield takeLatest(GET_LEADERBOARDS, getLeaderboards)
}
